import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Person } from '../types';

export const QueryKey = {
	TeamTracker: 'team-tracker',
};

interface TeamTrackerResponse {
	users: Person[];
}

interface UseTeamTrackerOptions {
	enabled?: boolean;
}

export const useTeamTracker = ({ enabled = true }: UseTeamTrackerOptions = {}) => {
	const http = useHttpClient('v2');

	return useQuery(
		[QueryKey.TeamTracker],
		() => {
			return http.get<TeamTrackerResponse>('team_members_tracker');
		},
		{
			select: (data) => data.data.users,
			// NOTE: always refetch on mount because we have different query clients
			// one for the bonus-feed which renders the tracker widget
			// and another for the growth page where feedback can be deleted
			// when feedback is deleted, we need to refetch the tracker widget data
			// but the bonus feed is not mounted so it cannot listen for events
			refetchOnMount: 'always',
			retry: false,
			enabled,
		}
	);
};
